import React from "react";
import { resetPassword } from "../../api/auth";

export default function ResetPasswordForm({ logoUrl, token, onSuccess, onResendLink }) {
  const [newPassword, setNewPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [linkExpired, setLinkExpired] = React.useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");

    if (newPassword !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }

    if (newPassword.length < 8) {
      setErrorMessage("Password must be at least 8 characters.");
      return;
    }

    setIsSubmitting(true);

    try {
      await resetPassword(token, newPassword);
      onSuccess();
    } catch (error) {
      console.error(error);
      if (error?.status === 400) {
        setErrorMessage(error?.payload?.message ?? "This reset link is invalid or has expired.");
        setLinkExpired(true);
      } else {
        setErrorMessage("Unable to reset your password right now. Please try again.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-shell">
      <section className="auth-card" aria-labelledby="reset-title">
        <div className="auth-branding">
          <img className="auth-logo" src={logoUrl} alt="Meditec Staffing Company" />
          <h1 id="reset-title">Set new password</h1>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <p className="auth-help-text">Create a strong password with at least 8 characters.</p>

          <label className="field" htmlFor="new-password">
            <span>New Password</span>
            <input
              id="new-password"
              type="password"
              autoComplete="new-password"
              value={newPassword}
              onChange={(event) => setNewPassword(event.target.value)}
              disabled={isSubmitting}
            />
          </label>

          <label className="field" htmlFor="confirm-password">
            <span>Confirm Password</span>
            <input
              id="confirm-password"
              type="password"
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              disabled={isSubmitting}
            />
          </label>

          <button
            type="submit"
            className="primary-action auth-submit"
            disabled={isSubmitting || !newPassword || !confirmPassword}
          >
            {isSubmitting ? "Saving..." : "Set password"}
          </button>
        </form>

        {errorMessage ? (
          <div className="status-message error" role="alert">
            {errorMessage}
          </div>
        ) : null}

        {linkExpired && onResendLink ? (
          <button type="button" className="auth-back-link" onClick={onResendLink}>
            Resend reset link
          </button>
        ) : null}
      </section>
    </div>
  );
}
